export const Constants = {
  BANNER_HEADING: "Welcome to the Manage Sync",
  BANNER_PARAGRAPH: "CPQ platform! Simplify your process to manage sync.",
  BREADCRUMB_NAME: "Manage Sync",
  MANUALSYNC:"Manual Sync",
  MANUALQUOTESSYNC:"Sync Quotes",
  CONFIRM:"Confirm",
  SYNCCONFIRMATION:"Do you want to proceed with CRM sync?",
  QUOTESYNCCONFIRMATION:"Do you want to proceed with CPQ to CRM quotes sync?",
  SUCCESSMESSAGE:"Successfully synced CRM data",
  QUOTESYNCSUCCESSMESSAGE:"Successfully synced quotes to CRM",
  ERRORMESSAGE:"Something went wrong, please try again.",
  PAGEMESSAGE:"Click 'Manual Sync' button to sync the master data (Product, Component, Pricing Structure, Currency and Country) from CRM to CPQ.",
  QUOTESYNCMESSAGE:"Click 'Sync Quotes' button to sync the failed quotes, update missing data in quotes from CPQ to CRM."
};
